<!--======= Banner Form Start Here ========-->
<div class="overflow">
    <div id="main-wrapper">
        <div class="site-wrapper-reveal">
            <div class="position-relative w-100">
                <div class="d-flex align-items-center w-100">

                    <img src="../../../assets/images/banners/journey-to-cloud.png" alt="journey-to-cloud Banner"
                        class="img img-responsive w-100 h-100 d-none d-md-block" width="100"  >

                    <img src="../../../assets/images/banners/cyber-mobileview.jpg" 
                        class="img-fluid h-100 w-100 img-responsive d-block d-md-none" width="100" alt="cyber view mobile banner" >

                    <div class="position-absolute w-100 home-banner">
                        <div class="row h-100 w-100">
                            <div class="col-8 col-md-4 col-sm-6 banner-section">
                              
                                <div class="align-items-center banner-content-title  global_title global_banner_title" role="heading">
                                    <span>The journey to Cloud with Maganti IT: Our playbook to cloud migration success</span>
                                </div>
                                <div class="global_sub_title global_banner_subtitle mt-2">
                                    <span>Lead your cloud adoption with confidence using our proven cloud migration framework by our cloud experts!</span>
                                </div>                          
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--======= Banner End Here ========-->

<!--======= Form start Here ========-->

    <div id="formpage">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-12">
                    <!-- <div  style="color: #000; font-size: 33px; font-weight: 500; margin-top: 80px">
                        Sparkminds Coding Contest: Unleash Your Coding Talent!
                    </div> -->
                    <div class="application_service-subcontent global_section_content pt-5">
                        <p class="pt-5">
                            <!-- In today's competitive tech landscape, investing in software training transcends certifications. It's about skill expansion, standing out in the job market, fostering adaptability, boosting productivity, and refining problem-solving skills. -->
                        <!-- Are you passionate about coding? Do you dream of showcasing your skills and making a mark in the tech world? Sparkminds is thrilled to announce an exciting opportunity for coders like you! We are conducting a coding contest that aims to identify and celebrate coding talent. This is your chance to shine, learn, and compete with fellow coding enthusiasts.   -->
                        Cloud adoption is more than just a technological shift. It’s a strategic advantage for driving business growth and efficiency. But let’s be honest—the path to effective cloud adoption isn’t always straightforward. Many businesses encounter roadblocks such as security concerns, cost management, migration complexity, and performance issues.
                        </p>
                        <p class="pt-2">
                        This resource offers guidance to businesses struggling to navigate the challenges of cloud adoption. Download our resource to unlock actionable insights, strategies, and understand the blueprint for successful cloud adoption.</p>
                        <p class="pt-2">
                           In this guide, we'll help you understand:
                             </p> 
                             <ul class="px-2">
                            <li>How to conduct a cloud readiness assessment and why it’s crucial.</li>
                            <li>Best practices for designing a secure cloud landing zone.</li>
                            <li>Strategies for choosing the right cloud services for your business.</li>
                            <li>Ways to foster innovation and achieve sustainable growth.</li>
                            <li>And much more.</li></ul>
                      
                        <p class="pt-2">
                        Get your hands on this essential guide and equip yourself with the knowledge and strategies needed for real growth. Download the resource now!
                        </p>
                        <!-- <h3 style="color : #AC59FD ;" class="fs-1">Why Participate?</h3>
                        <p class="mt-2">
                        <span style="color:#AC59FD; font-weight:bold">- Attractive Cash Prizes:</span> &nbsp; Winners of the contest will be rewarded with handsome cash prizes. It’s not just about the competition; it's also about rewarding your hard work and talent.
                        </p>
                        <p class="mt-2">
                        <span style="color:#AC59FD; font-weight:bold">- Showcase Your Talent:</span> &nbsp;  This contest is the perfect stage to display your coding skills to a broad audience, including industry leaders and peers. Stand out from the crowd and make a name for yourself.
                        </p>
                        
                        <p class="mt-2">
                        <h3 style="color : #AC59FD ;" class="fs-1">How to Enter the Challenge:</h3> <br>
                
                            1. Fill out the participation form with your details to enter the contest.<br>
                            2. Upon registration, you will receive detailed information about the contest, including its scheduled time and date.<br>
                            3. Make sure you’re ready to showcase your coding prowess at the designated time!
                        </p> -->
                    </div>
                </div>

                    
                <div class="col-sm-12 col-lg-6 col-md-12  intern_formcol" id='sectionOne' style="top:30%;">
                    <div class="border border-1  p-3 intern_forDiv">
                        <div class=" text-center m-1 mt-4 py-2 h1 sbtDiv" style="color:#182357; font-size:23px;" role="heading"> <b>Download the E-Book</b> </div>
                        <form [formGroup]="form" (ngSubmit)="onSubmit()">
                            <div class="form-floating"  style="height:60px">
                                <input type="text" class="form-control my-4" style="height:50px;" aria-required="true"
                                    id="ebookfirstName" formControlName="FirstName" placeholder="*First Name" autocomplete="off" required>
                                <label for="ebookfirstName" class="text-secondary">First Name*</label>
                                <div id="int_Country" style="margin-top: -22px;" >
                                    <span *ngIf="form.get('FirstName')?.invalid && form.get('FirstName')?.touched">
                                        {{ getErrorMessage('FirstName') }}
                                      </span>
                                </div>
                            </div>
                            
                            <div class="form-floating" style="height:60px">
                                <input type="text" class="form-control my-4" style="height:50px;" aria-required="true"
                                     id="ebooklastName" formControlName="LastName" placeholder="*Last Name" autocomplete="off" required>
                                <label for="ebooklastName" class="text-secondary">Last Name*</label>
                                <div id="int_Country" style=" margin-top: -22px;">
                                    <span *ngIf="form.get('LastName')?.invalid && form.get('LastName')?.touched">
                                        {{ getErrorMessage('LastName') }}
                                    </span>
                                </div>
                            </div>
                            <div class="form-floating " style="height:60px">
                                <input type="email" class="form-control my-4" autocomplete="off" aria-required="true"
                                    style="height:50px;" id="inputworkEmail" formControlName="Email" placeholder="*Email" required>
                                <label for="inputworkEmail" class="text-secondary" >Work Email*</label>
                                <div id="int_Country" style="margin-top: -22px;">
                                    <span *ngIf="form.get('Email')?.invalid && form.get('Email')?.touched">
                                        {{ getErrorMessage('Email') }}
                                    </span>
                                    <!-- <div *ngIf="isFormControlInvalid('Email')" class="formError"> {{ getErrorMessage('Email') }}</div> -->
                               
                                </div>
                            </div>
                
                            <div class="form-floating " style="height:60px"> 
                                <input type="text" class="form-control my-4" autocomplete="off" aria-required="true"
                                    style="height:50px;" id="inputCompanyName" formControlName="CompanyName" placeholder="*Company Name" required>
                                <label for="inputCompanyName" class="text-secondary">Company Name*</label>
                                <div id="int_Country" style="margin-top: -22px;">
                                    <span *ngIf="form.get('CompanyName')?.invalid && form.get('CompanyName')?.touched">
                                        {{ getErrorMessage('CompanyName') }}
                                    </span>
                                </div>
                            </div>
                
                            <div class="form-floating  " style="height:60px; margin-bottom: 15px;">
                                <input type="text" class="form-control my-4" autocomplete="off" aria-required="true"
                                    style="height:50px;" id="inputJob" formControlName="JobTitle" placeholder="*Job Title" required>
                                <label for="inputJob" class="text-secondary">Job Title*</label>
                                <div id="int_Country" style="margin-top: -22px;">
                                    <span *ngIf="form.get('JobTitle')?.invalid && form.get('JobTitle')?.touched">
                                        {{ getErrorMessage('JobTitle') }}
                                    </span>
                                </div>
                            </div>
                
                            <div class="form-floating  " style="height:60px; margin-bottom: 15px;">
                                <input type="text" class="form-control my-4" autocomplete="off" aria-required="true"
                                    style="height:50px;" id="inputCountry" formControlName="Country" placeholder="*Country" required>
                                <label for="inputCountry" class="text-secondary">Country*</label>
                                <div id="int_Country" style="margin-top: -27px;">
                                    <span *ngIf="form.get('Country')?.invalid && form.get('Country')?.touched">
                                        {{ getErrorMessage('Country') }}
                                    </span>
                                </div>
                            </div>
                
                            <div class="d-grid gap-2" style="height:50px; background: transparent linear-gradient(175deg, #9442EA 0% ) 0% 0% no-repeat padding-box!important;margin-top: 39px;margin-left: 10%; width: 80%;color: white;">
                                <button type="submit" class="btn btn-lg" id="submitBtn" style="height:50px;" [disabled]="form.invalid || isSubmitting" (click)="onSubmit()"> 
                                    Submit Your Details
                                </button>
                            </div> 
                              <div *ngIf="loading" class="loader-container">
                          <mat-spinner></mat-spinner>
                          <div class="loader-wheel"></div>
                        </div>
                        </form>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
<!--======= Form End Here ========-->


<!-- =======customer stories section starts ======== -->
<div class="container-fluid p-0">
            <div class="row">
                <div class="casestudy-mainsection col-12 col-sm-12 mt-5" data-aos="fade-up">
                <h3>Related Resources</h3>
                    <div class="insight-subtitles global_sub_title casestudy-subtitle my-3 my-lg-5 text-black"> 
                        Maganti IT Resources has established relationships with some of the leading companies in the globe. 
                        Together, we help clients design and realize the future of
                        their business with modern delivery methods and cloud innovation.
                    </div>
                </div>
            </div>
            <div class="button-container">
                <button id="showImagesButton">Case Studies</button> 
                <button id="showImages2Button">Use Cases</button>
            </div>
            <div class="image-container case-studies-content pe-0" id="image-container1">
                <div class="container-fluid rowsizes">
                    <div class="blogs-bgimage">
                        <div class="row ">
                            <!-- <div class="col-md-12 col-sm-12">
                                <div class="col-md-12 col-sm-12">
                                    <div class="row justify-content-center ">
                                        <div class="row justify-content-center "> -->
    
                                            <div
                                                class=" blog-cardsection col-lg-4 col-md-6 col-sm-12 filter digital_marketing">
                                                <div class="card-group">
                                                    <div class="insight-cards">
                                                        <img class="card-img-top"
                                                            src="../../../assets/images/homepage/CaseStudies-imd-1.png"
                                                            alt="CaseStudies-imd-1" />
                                                        <div class="cards-body">
                                                            <h5 class="card-text global_titles pt-3 text-black">Supercharge
                                                                with Cloud & Automation
                                                            </h5>
                                                            <p class="casestudy-card-text global_section_contents pt-3">
                                                                Discover how a leading sensor technology giant transitioned
                                                                to the cloud for a significant IT transformation and
                                                                innovation.
                                                            </p>
                                                            <a href="futek-casestudy" aria-label="Go to futek casestudy">Read More</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
    
                                            <div
                                                class=" blog-cardsection col-lg-4 col-md-6 col-sm-12 filter digital_marketing">
                                                <div class="card-group">
                                                    <div class="insight-cards">
                                                        <img class="card-img-top"
                                                            src="../../../assets/images/homepage/CaseStudies-imd-2.png"
                                                            alt="Opinion polling Casestudy" />
                                                        <div class="cards-body">
                                                            <h5 class="card-text global_titles pt-3 text-black">Opinion
                                                                polling made seamless with Cloud
                                                            </h5>
                                                            <p class="casestudy-card-text global_section_contents pt-3">
                                                                Learn how we built a global website, with minimal downtime,
                                                                with future cloud advances incorporated into client's IT
                                                                infrastructure.
                                                            </p>
                                                            <a href="ouropinion-casestudy" class="read-more casestudy-read" aria-label="Read Ouropinion Casestudy">Read More</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
    
                                            <div
                                                class=" blog-cardsection col-lg-4 col-md-6 col-sm-12 filter digital_marketing">
                                                <div class="card-group">
                                                    <div class="insight-cards">
                                                        <img class="card-img-top"
                                                            src="../../../assets/images/homepage/CaseStudies-imd-3.png"
                                                            alt="CaseStudies" />
                                                        <div class="cards-body">
                                                            <h5 class="card-text global_titles pt-3 text-black">
                                                                Innovation-led application services
                                                            </h5>
                                                            <p class="casestudy-card-text global_section_contents pt-3">
                                                                Learn how we built an all-in-one multi- faceted platform for
                                                                CuroRc making it faster, convenient, more secure, and less
                                                                expensive.
                                                            </p>
                                                            <a href="curorc" class="read-more" aria-label="Learn more about curorc">Read More</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        <!-- </div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
    
            </div>
            <div class="image-container use-cases-content pe-0" id="image-container2">
                <div class="container-fluid rowsizes">
                    <div class="blogs-bgimage">
                        <div class="row ">
                            <!-- <div class="col-md-12 col-sm-12">
                                <div class="col-md-12 col-sm-12">
                                    <div class="row justify-content-center ">
                                        <div class="row justify-content-center pt-5"> -->
                                            <div
                                                class=" blog-cardsection col-lg-4 col-md-6 col-sm-12 filter digital_marketing">
                                                <div class="card-group">
                                                    <div class="insight-cards">
                                                        <img class="card-img-top"
                                                            src="../../../assets/images/homepage/UseCases-img-1.png"
                                                            alt="Cloud optimization Usecase" />
                                                        <div class="cards-body">
                                                            <h5 class="card-text global_titles pt-3 text-black">Client
                                                                Story: Cloud optimization strategies that drove 50% cost
                                                                savings </h5>
                                                            <p class="casestudy-card-text global_section_contents pt-3">
                                                                Unlock our nine essential cloud optimization best practices,
                                                                proven to cut overspending by 20-50% </p>
                                                            <a href="cloud-cost-optimization" class="read-more" aria-label="View Cloud Cost Optimization">Read
                                                                More</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class=" blog-cardsection col-lg-4 col-md-6 col-sm-12 filter digital_marketing">
    
                                                <div class="card-group">
                                                    <div class="insight-cards">
                                                        <img class="card-img-top"
                                                            src="../../../assets/images/homepage/UseCases-img-2.png"
                                                            alt="Cloud Capacity Usecase" />
                                                        <div class="cards-body">
                                                            <h5 class="card-text global_titles pt-3 text-black">Planning
                                                                Cloud capacity for unexpected Spikes in Server Workloads
                                                            </h5>
                                                            <p class="casestudy-card-text global_section_contents pt-3">IT
                                                                teams are required to architect applications to handle
                                                                fluctuations in scale by proper capacity planning. Learn
                                                                how.</p>
                                                            <a href="cloud-cost-optimization" class="read-more" aria-label="View Cloud Cost Optimization">Read
                                                                More</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
    
                                            <div
                                                class=" blog-cardsection col-lg-4 col-md-6 col-sm-12 filter digital_marketing">
                                                <div class="card-group">
                                                    <div class="insight-cards">
                                                        <img class="card-img-top"
                                                            src="../../../assets/images/homepage/UseCases-img-3.png"
                                                            alt="Usecases" />
                                                        <div class="cards-body">
                                                            <h5 class="card-text global_titles pt-3 text-black">Navigating
                                                                the Maze: Hurdles in Embracing Manufacturing IT and Industry
                                                                4.0</h5>
                                                            <p class="casestudy-card-text global_section_contents pt-3">
                                                                Learn the biggest challenges faced by manufacturing clients
                                                                in technology adoption in Industry 4.0 and how Maganti IT
                                                                can be their right-sized partner of choice.</p>
                                                            <a href="challenges-manufacturing-it-industry-4-0"
                                                                class="read-more" aria-label="Read challenges in manufacturing">Read More</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                        </div>
                    </div>
                </div>
            </div>  


        <div class="customer-button text-center py-5">
            <a routerLink="/careers" href="/careers" class="global_button" aria-label="View Careers Page">
                <div class="dub-arrow"><img src="../../assets/images/button/arrowBlack.png" alt="careers - Explore for more Resources" /></div>EXPLORE MORE RESOURCES</a>
        </div>
</div>
<!-- =======customer stories section ends ======== -->

<div class="modal" id="myModal46">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <div class="career-modal global_sub_title mx-5 ">Software Engineering</div>
          <!-- <button type="button" class=" career_closebutton" data-dismiss="modal">&times;</button> -->
        </div>  
        <div class="modal-body">
            <div class='page-meta career_popupcontent'>
            </div>
            <div class="career_popupcontent">Get trained with an internship in Software engineering. Begin your first career and grow to higher roles such as Software Development Engineer (In Test), Project/ Technical Lead, Project/Technical Manager, Technical Architect, and more either at a module, subsystem, system, application, solution/product or project level.</div>
            <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
            <div class="career_popupcontent">
            
            <div class="Contents">
                    <div class="global_section_content ouropinion_subcontent">
                          <b>Eligibility:</b>Bachelor’s Degree in Computer Science, Information Technology, Information Systems, Electrical, Electronics, Mechanical Engineering or other STEM Majors like Math & Science.
                    </div><br>
                    <b>What you’ll learn:</b>
                     <ul style="list-style-type:disc; line-height: 30px; color: black;">
                               <li> Manage individual project priorities, deadlines and deliverables.</li>
                               <li>Write design documents and participate in design reviews.</li>
                               <li>Setup environment and participate in testing/ trouble shooting existing software issues and implement as per the change management process and bug fixes.</li>
                               <li>Optimize developed systems for performance and reliability.</li>
                               <li>Operating System provisioning and Storage configuration</li>
                               <li>Develop functions, scripts, stored procedures and triggers to support application development.</li>
                               <li>Use applicable methodologies, modeling/ estimating techniques, tools, applications, systems, software and/or databases to perform assigned tasks. </li>
                    </ul>
                 
                </div>
        </div>
            <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
            <div class="career_popupcontent">hr&#64;mitresource.com</div>
        </div>
        <div class="modal-footer">
          <button type="button" class="modal_button  btn " data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
</div>


<div class="modal" id="myModal47"> 
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <div class="career-modal global_sub_title mx-5 ">Cloud Services</div>
          <!-- <button type="button" class=" career_closebutton" data-dismiss="modal">&times;</button> -->
        </div>  
        <div class="modal-body">
            <div class='page-meta career_popupcontent'>
                <!-- <div class='row'>
                    <div class='col-xs-12 col-sm-3 py-0'>
                        <div><span class='c-orange job-career-title'>Locations:</span> &nbsp; Waterbury - USA</div>
                    </div>
                    <div class='col-xs-12 col-sm-2 py-0  w-20'>
                        <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                    </div>
                    <div class='col-xs-12 col-sm-3 py-0 w-30'>
                        <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp;  November 17,2023</div>
                    </div>
                    <div class='col-xs-12 col-sm-3 py-0'>
                        <div><span class='c-orange job-career-title'>End Date:</span> &nbsp;  December  21,2023</div>
                    </div>
                </div> -->
            </div>
            <!-- <hr/> -->
            <div class="career_popupcontent">
            <div class="Contents">
                    <div class="global_section_content ouropinion_subcontent">
                    Start your journey on Cloud computing with training and internship opportunities. Begin as a Cloud Administrator to steadily advance your career, vertically to Cloud Architect, or explore opportunities to grow to other technologies.
                    </div>
                    <div class="global_section_content ouropinion_subcontent">
                          <b>Eligibility:</b> Bachelor’s Degree in Computer Science, Information Technology, Information Systems, Electrical, Electronics, Mechanical Engineering or other STEM Majors like Math & Science.
                          <p>As a Cloud Administrator Intern, you would learn and perform the following responsibilities:</p>
                    </div><br>
                    <b>What you’ll learn:</b>As a Cloud Administrator Intern, you would learn and perform following responsibilities.
                     <ul style="list-style-type:disc; line-height: 30px; color: black;">
                               
                               <li>Gain hands-on experience setting up and managing scalable, secure, and efficient cloud infrastructure. Learn resource allocation for optimized utilization and cost-effectiveness.</li>
                               <li>Acquire skills in implementing robust security measures to safeguard cloud-based systems and data. Understand monitoring techniques to identify bottlenecks and enhance overall system efficiency.</li>
                               <li>Master the essentials of designing and implementing backup and recovery strategies for cloud-based data and applications. Explore collaborative tools for effective communication in a cloud-based environment.</li>
                               <li>Develop problem-solving skills to address issues related to cloud infrastructure, ensuring seamless operations. Cultivate a habit of thorough documentation for configurations, processes, and troubleshooting steps.</li>
                               <li>Interact cross-functionally and conduct end-to-end analysis, from processing data to presenting results, in collaboration with various teams. Utilize analytical methods on large, complex datasets for open-ended problem-solving.</li>
                               <li>Collaborate closely with engineers to identify opportunities for and assess improvements to organizational products.</li>
                        </ul>
                    <!-- </ul> -->

                            <!-- <div class="global_section_content ouropinion_subcontent">
                                <h6>Career Path</h6> Cloud Services
                            </div> -->
                </div>
            
        </div>
        <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
            <div class="career_popupcontent">Bachelor of Science or related field required. </div>

            <div class="career_popupcontent">hr&#64;mitresource.com</div>
        </div>
        <div class="modal-footer">
          <button type="button" class="modal_button  btn " data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
</div>


<div class="modal" id="myModal48">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <div class="career-modal global_sub_title mx-5 ">FullStack Development</div>
          <!-- <button type="button" class=" career_closebutton" data-dismiss="modal">&times;</button> -->
        </div>  
        <div class="modal-body">
            <div class='page-meta career_popupcontent'>
                    <!-- <div class='row'>
                        <div class='col-xs-12 col-sm-3 py-0'>
                            <div><span class='c-orange job-career-title'>Locations:</span> &nbsp; Waterbury - USA</div>
                        </div>
                        <div class='col-xs-12 col-sm-2 py-0  w-20'>
                            <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                        </div>
                        <div class='col-xs-12 col-sm-3 py-0 w-30'>
                            <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp;  November 17,2023</div>
                        </div>
                        <div class='col-xs-12 col-sm-3 py-0'>
                            <div><span class='c-orange job-career-title'>End Date:</span> &nbsp;  December  21,2023</div>
                        </div>
                    </div> -->
            </div>
            <!-- <hr/> -->
            <div class="career_popupcontent">
            <div class="Contents">
                    <div class="global_section_content ouropinion_subcontent">
                    Bachelor’s Degree in Data Science, Math, Statistics, Computer Science, Information Systems or Information Technology.
                        Begin as a Cloud Administrator to steadily advance your career, vertically to Cloud Architect, or explore opportunities to grow to other technologies.
                    </div>
                    <div class="global_section_content ouropinion_subcontent">
                          <b>Eligibility:</b> Bachelor’s Degree in Computer Science, Information Technology, Information Systems, Electrical, Electronics, Mechanical Engineering or other STEM Majors like Math & Science.
                    </div>
                    <b>What you’ll learn:</b> As a Full Stack development Intern, you would learn and perform following responsibilities.
                                    <ul style="list-style-type:disc; line-height: 30px; color: black;">
                                        
                                        <li>Participate in the complete software development lifecycle, from concept and design to testing and deployment. </li>
                                        <li>Learn and apply skills in building responsive and user-friendly interfaces using modern web technologies such as HTML, CSS, and JavaScript. </li>
                                        <li>Gain proficiency in server-side scripting, database management, and server deployment to ensure seamless functionality and performance. </li>
                                        <li>Acquire skills in designing and managing databases to ensure efficient storage and retrieval of data.</li>
                                        <li>Learn to create and integrate APIs, facilitating communication between different parts of a web application.</li>
                                        <li>Understand and utilize version control systems like Git for efficient collaboration and code management. </li>
                                        <li>Develop skills in testing code for functionality, identifying and resolving bugs to ensure the reliability of applications.</li>
                                        <li>Work collaboratively within a team, participating in code reviews and contributing to the overall success of the development projects.</li>
                                        <li>Learn and implement coding standards, best practices, and industry trends to ensure high-quality and maintainable code.</li>
                                        <li>Stay updated on emerging technologies and trends in full-stack development, fostering a culture of continuous learning and improvement.</li>
                                    </ul>
                                <!-- </li> -->
                            <!-- </ul> -->

                            <!-- <div class="global_section_content ouropinion_subcontent">
                                <h6>Career Path</h6> Cloud Services
                            </div> -->
                </div>
            
        </div>
        <!-- <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
            <div class="career_popupcontent">Bachelor of Science or related field required. </div>

            <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
            <div class="career_popupcontent">hr@mitresource.com</div> -->
        </div>
        <div class="modal-footer">
          <button type="button" class="modal_button  btn " data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
</div>


<div class="modal" id="myModal49">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <div class="career-modal global_sub_title mx-5 ">Testing</div>
          <!-- <button type="button" class=" career_closebutton" data-dismiss="modal">&times;</button> -->
        </div>  
        <div class="modal-body">
            <div class='page-meta career_popupcontent'>
                <!-- <div class='row'>
                    <div class='col-xs-12 col-sm-3 py-0'>
                        <div><span class='c-orange job-career-title'>Locations:</span> &nbsp; Waterbury - USA</div>
                    </div>
                    <div class='col-xs-12 col-sm-2 py-0  w-20'>
                        <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                    </div>
                    <div class='col-xs-12 col-sm-3 py-0 w-30'>
                        <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp;  November 17,2023</div>
                    </div>
                    <div class='col-xs-12 col-sm-3 py-0'>
                        <div><span class='c-orange job-career-title'>End Date:</span> &nbsp;  December  21,2023</div>
                    </div>
                </div> -->
            </div>
            <!-- <hr/> -->
            <div class="career_popupcontent">
            <div class="Contents">
            <div class="global_section_content ouropinion_subcontent">
                          <b>Eligibility:</b>  Bachelor’s Degree in Computer Science, Information Technology, Information Systems, Electrical, Electronics, Mechanical Engineering or other STEM Majors like Math & Science.
                          <p>As a Testing Intern, you will acquire valuable skills and knowledge in the field of software testing. Your learning experience will encompass the following key areas:</p>
                    </div> <br>
                    <b>What you’ll learn:</b> As a Cloud Administrator Intern, you would learn and perform following responsibilities.

                                    <ul style="list-style-type:disc; line-height: 30px; color: black;">
                                        <li> Understand different testing methodologies, such as manual testing, automated testing, and performance testing, to ensure comprehensive coverage of software quality assurance.</li>
                                        <li>Learn to create effective test plans and documentation, outlining the testing strategy, scope, and test cases for various software components.</li>
                                        <li>Develop the skill of designing clear and comprehensive test cases that cover different scenarios to validate software functionality.</li>
                                        <li>Familiarize yourself with automated testing tools and frameworks to enhance testing efficiency and repeatability.</li>
                                        <li>Understand the importance of regression testing and learn techniques to ensure that new developments do not adversely affect existing functionalities.</li>
                                        <li>Gain insights into performance testing methodologies to evaluate the responsiveness, speed, and overall stability of software applications under varying conditions.</li>
                                        <li>Learn about the life cycle of defects, from identification to resolution, and the importance of clear communication between testers and developers.</li>
                                        <li>Work collaboratively within a development team, participating in discussions, and contributing insights to improve the overall software quality.</li>
                                        <li>Embrace a culture of continuous improvement, staying updated on the latest testing tools, methodologies, and industry best practices.</li>
                                    </ul>
                                <!-- </li> -->
                            <!-- </ul> -->
                            <!-- <div class="global_section_content ouropinion_subcontent">
                                <h6>Career Path</h6> Cloud Services
                            </div> -->
                </div>
            
        </div>
        <!-- <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
            <div class="career_popupcontent">Bachelor of Science or related field required. </div>

            <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
            <div class="career_popupcontent">hr@mitresource.com</div> -->
        </div>
        <div class="modal-footer">
          <button type="button" class="modal_button  btn " data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
</div>

<div class="modal" id="myModal50">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
            <div class="career-modal global_sub_title mx-5 ">AI/ML</div>
        </div>  
        <div class="modal-body">
            <div class='page-meta career_popupcontent'>
             
            </div>
            <div class="career_popupcontent">
                <div class="Contents">
                    <div class="global_section_content ouropinion_subcontent">
                          <b>Eligibility:</b> Bachelor’s Degree in Data Science, Math, Statistics, Computer Science, Information Systems or Information Technology. 
                              Those who begin as Entry Level Data Engineers can pursue a career in Data Engineering, Data Analysis, or Data Science and eventually advance to 
                              become Technical Architects, Solution Architects, Chief Data Scientists, or to lead the entire practise.<br>
                              <p> As an AI/ML Intern, you will gain valuable insights and skills in the dynamic field of Artificial Intelligence and Machine Learning. Here's what you can expect to learn. </p>
                                <b>What you’ll learn:</b>

                                    <ul style="list-style-type:disc; line-height: 30px; color: black;">
                                        <li> Acquire a solid understanding of the foundational concepts and principles behind Artificial Intelligence and Machine Learning.</li>
                                        <li>Learn the crucial step of cleaning and transforming raw data into a suitable format for machine learning models.</li>
                                        <li>Understand the principles of both supervised learning (classification, regression) and unsupervised learning (clustering, dimensionality reduction).</li>
                                        <li>Gain hands-on experience in developing machine learning models using popular frameworks and libraries such as TensorFlow or PyTorch.</li>
                                        <li>Model Evaluation: Learn how to assess the performance of machine learning models, including metrics like accuracy, precision, recall, and F1 score.</li>
                                        <li>Understand the importance of feature selection and engineering to enhance the performance of machine learning models. </li>
                                        <li>Dive into the world of deep neural networks, learning about architectures like convolutional neural networks (CNNs) and recurrent neural networks (RNNs).</li>
                                        <li>Explore the applications of machine learning in understanding and processing human language.</li>
                                        <li>Gain insights into how mUnderstand the ethical implications of AI/ML, including bias in algorithms and responsible AI practices.achine learning is applied in computer vision tasks, such as image recognition and object detection.</li>
                                        <li>Learn the process of deploying machine learning models into production environments for practical applications.</li>
                                        <li>Collaboration and Communication: Develop skills in collaborating with team members, presenting findings, and effectively communicating complex concepts.</li>
                                    </ul>
                    </div>
                </div>
                  
            </div>
            <div class="modal-footer">
            <button type="button" class="modal_button  btn " data-dismiss="modal">Close</button>
            </div>
      </div>
      </div>
    </div>
</div>